// https://github.com/mui/material-ui/issues/36448#issuecomment-1556738360
import { useLayoutEffect, useState } from 'react';

export default () => {
    const [wasInitiallyAutofilled, setWasInitiallyAutofilled] = useState(false);

    useLayoutEffect(() => {
        /**
         * You can access chrome://flags/#unsafely-treat-insecure-origin-as-secure in your navigation bar
         * and add your domain there for enable autofill in local development
         */
        let autofilled = false;
        const checkAutofill = () => {
            if (autofilled) return;
            const inputElements = document.getElementsByTagName('input');
            if (!inputElements) return;
            for (let i = 0; i < inputElements.length; i++) {
                const input = inputElements[i];
                const isAutofilled = input.matches('*:-webkit-autofill');
                if (isAutofilled) {
                    autofilled = true;
                    break;
                }
            }
            setWasInitiallyAutofilled(autofilled);
        };
        // The time when it's ready is not very stable, so check few times
        setTimeout(checkAutofill, 500);
        setTimeout(checkAutofill, 1000);
        setTimeout(checkAutofill, 2000);
    }, []);

    return wasInitiallyAutofilled;
};
